export default "__VITE_ASSET__BvNtLLlk__"